export default function noop() {
    return undefined;
}
